import Echo from 'laravel-echo'

export default {

  data() {
    return {
      channel: null,
      users: [],
    }
  },

  mounted() {
    if (!this.$root.userSessionActive) {
      console.log('USER SESSION WAS NOT ACTIVE');
    }

    if (this.userIsInTeam && this.$root.userSessionActive) {

      Bus.$on("joined-team-channel", (user) => {
        this.channel.whisper('member-init-data', {
          user: user,
          // queue: this.queue
        });
      });

      Bus.$on("team-channel-dashboard-event", data => {
        console.log('team-channel-dashboard-event event fired! event: ', data.event);

        data.userId = this.spark.state.user.id

        this.channel.whisper('team-channel-dashboard-event-receiver', data);
      });

    }
  },

  methods: {

    initTeamChannel() {
      console.log('[ initTeamChannel ]')
      // console.log('this.spark.state.user: ', this.spark.state.user);
      // console.log('this.spark.state.currentTeam: ', this.spark.state.currentTeam.owner.region);
      let socketDomain = this.spark.state.currentTeam.owner.region === 'KR' ? 'sgp.sockets.snazzydocs.com' : 'sockets.snazzydocs.com'


      if (!window.hasOwnProperty('Pusher') && !window.hasOwnProperty('Echo')) {
        window.Pusher = require('pusher-js');

        window.Echo = new Echo({
          broadcaster: 'pusher',
          key: process.env.MIX_PUSHER_APP_KEY,
          cluster: process.env.MIX_PUSHER_APP_CLUSTER,

          host: window.location.hostname === 'app.snazzydocs.test' ? 'sockets.snazzydocs.test' : socketDomain,
          wsHost: window.location.hostname === 'app.snazzydocs.test' ? 'sockets.snazzydocs.test' : socketDomain,
          wssHost: window.location.hostname === 'app.snazzydocs.test' ? 'sockets.snazzydocs.test' : socketDomain,
          wsPort: 443,
          wssPort: window.location.hostname === 'app.snazzydocs.test' ? 6001 : 443,

          disableStats: true,
          scheme: 'https',

          enabledTransports: ['ws'],
        });
      }

      if (window.hasOwnProperty('Pusher') && window.hasOwnProperty('Echo')) {
        this.joinTeamChannel()
      }
    },

    userInChannel(user) {
      return this.indexWhere(this.users, _user => _user.id === user.id) > 0
    },

    joinTeamChannel() {
      console.log('[ joinTeamChannel ]');

      this.channel = window.Echo.join(`team-${this.spark.state.currentTeam.id}`)
        .here((users) => {
          // Get all the other users data
          Vue.set(this, 'users', users)
        })
        .joining((user) => {
          if (!this.userInChannel(user)) this.users.push(user)
        })
        .leaving((user) => {
          Vue.delete(this.users, this.indexWhere(this.users, _user => _user.id === user.id))
        })
        .listenForWhisper('member-init-data', (data) => {
          // console.log('this.channel.subscription.members: ', this.channel.subscription.members);

          if (data.user.hasOwnProperty('selectedPageId') && data.user.selectedPageId) {
            Vue.set(this.channel.subscription.members.members[data.user.id], 'selectedPageId', data.user.selectedPageId)
          }

          if (data.user.hasOwnProperty('documentationId') && data.user.documentationId) {
            Vue.set(this.channel.subscription.members.members[data.user.id], 'documentationId', data.user.documentationId)
          }
        })
        .listenForWhisper('here-is-my-info', (user) => {
          if (!user) return

          if (!this.channel.subscription.members.members.hasOwnProperty(user.id)) return

          this.users.map(_user => {

            if (user.id === _user.id) {
              // Vue.set(_user, 'displayColor', user.displayColor)
              Vue.set(_user, 'selectedPageId', user.selectedPageId || null)
              Vue.set(this.channel.subscription.members.members[user.id], 'selectedPageId', user.selectedPageId)

              Vue.set(_user, 'documentationId', user.documentationId || null)
              Vue.set(this.channel.subscription.members.members[user.id], 'documentationId', user.documentationId)

              Vue.set(_user, 'photo_url', user.photo_url)
              Vue.set(this.channel.subscription.members.members[user.id], 'photo_url', user.photo_url)
            }
          })
        })
        .listenForWhisper('team-channel-dashboard-event-receiver', (data) => {
          Bus.$emit(`${data.event}_team-event`, data)
        })

    },

    indexWhere(array, conditionFn) {
      const item = array.find(conditionFn)

      return array.indexOf(item)
    },

  }
}
